import { render, staticRenderFns } from "./trainerCriteria.vue?vue&type=template&id=47c2bdbf&scoped=true"
import script from "./trainerCriteria.vue?vue&type=script&lang=js"
export * from "./trainerCriteria.vue?vue&type=script&lang=js"
import style0 from "./trainerCriteria.vue?vue&type=style&index=0&id=47c2bdbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c2bdbf",
  null
  
)

export default component.exports